var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
    _c("ul", { staticClass: "pagination justify-content-center" }, [
      _c("li", { staticClass: "page-item" }, [
        _c(
          "button",
          {
            staticClass: "page-link",
            attrs: {
              "aria-label": "Previous",
              disabled: !_vm.pagination.hasPrev,
            },
            on: {
              click: function ($event) {
                return _vm.goToNext()
              },
            },
          },
          [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.Lang.get("pagination.prev_page")) +
                "\n                "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "page-item" }, [
        _c(
          "button",
          {
            staticClass: "page-link",
            attrs: { "aria-label": "Next", disabled: !_vm.pagination.hasNext },
            on: {
              click: function ($event) {
                return _vm.goToPrev()
              },
            },
          },
          [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.Lang.get("pagination.next_page")) +
                "\n                "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }